import React, { memo } from "react";

import { isEmpty } from "@swiggy-private/js-utils";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

import { CALLOUTS_BANNER_DIMENSIONS } from "@dineout-payment-success-ui/constants/CalloutsBanner";
import { ICalloutsBannerHalfCardProps } from "@dineout-payment-success-ui/interfaces";
import { SUCCESS_PAGE_TEST_IDS } from "@swiggy-private/payment-test-ids";

import {
    CalloutsBannerHalfCardCtaWrap,
    CalloutsBannerHalfCardDescription,
    CalloutsBannerHalfCardHeader,
    CalloutsBannerHalfCardImageWrap,
    CalloutsBannerHalfCardTitle,
    CalloutsBannerHalfCardWrapper,
} from "./styles";

const CalloutsBannerHalfCard: React.FC<ICalloutsBannerHalfCardProps> = ({ callouts, onCtaClick }) => {
    if (isEmpty(callouts)) {
        return null;
    }

    const { title, image, description, ctaText } = callouts;

    return (
        <CalloutsBannerHalfCardWrapper data-testid={SUCCESS_PAGE_TEST_IDS.CALLOUTS_BANNER_HALF_CARD}>
            <CalloutsBannerHalfCardHeader>
                <CalloutsBannerHalfCardTitle
                    variant="V2.heading2.neutral.bold"
                    color="text_High_Emphasis"
                    dangerouslySetInnerHTML={{ __html: title || "" }}
                />
                {!isEmpty(image) && (
                    <CalloutsBannerHalfCardImageWrap>
                        <Image
                            cloudinaryId={image}
                            width={CALLOUTS_BANNER_DIMENSIONS.calloutImageWidthSize}
                            height={CALLOUTS_BANNER_DIMENSIONS.calloutImageHeightSize}
                            fit="contain"
                        />
                    </CalloutsBannerHalfCardImageWrap>
                )}
            </CalloutsBannerHalfCardHeader>
            <CalloutsBannerHalfCardDescription
                variant="V2.body3.neutral.regular"
                color="text_Med_Emphasis"
                dangerouslySetInnerHTML={{ __html: description || "" }}
            />
            <CalloutsBannerHalfCardCtaWrap>
                <SuperButton variant="fullwidth" buttonType="primary" buttonSize="large" onClick={onCtaClick}>
                    {ctaText}
                </SuperButton>
            </CalloutsBannerHalfCardCtaWrap>
        </CalloutsBannerHalfCardWrapper>
    );
};

export default memo(CalloutsBannerHalfCard);
